import React, { useEffect, useState } from "react";
import TenantInfo from "./tenantInfo";
import WelcomeHeader from "../../reusebale/welcomeHeader";
import BalancesSection from "./balances";
import MaintainanceTable from "./maintainance-request";
import LeaseTable from "./leaseTable";
import LandlordProfile from "./landlordProfile";
import BroadcastCarousel from "./broadcast";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import moment from "moment";
const Home = ({
  onViewDetails,
  onViewMaintainDetails,
  broadCastPage,
  onLeaseTable,
}) => {
  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );

  const [allLeases, setAllLeases] = useState([]);
  const [allMaintenance, setAllMaintenance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLease, setLoadingLease] = useState(false);

  const GetAllLeases = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getAllLeaseByTenant/${loginSuccess?.user?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllLeases(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetAllMaintenanceRequest = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/maintenence/getMeintenanceRequestByTenantId/${loginSuccess?.user?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllMaintenance(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllLeases();
    GetAllMaintenanceRequest();
  }, []);

  return (
    <div className="w-full h-full py-4">
      <WelcomeHeader content="Hi" subheading="Welcome Back" />
      <div className="my-5">
        <TenantInfo />
        <div className="flex justify-between">
          <div className="w-[49%]">
            <BroadcastCarousel broadCastPage={broadCastPage} />
          </div>
          <div className="w-[49%]">
            {/* <BalancesSection handleLeaseTable={onLeaseTable} /> */}
            <LandlordProfile />
          </div>
        </div>
        <LeaseTable allLeases={allLeases} onViewDetails={onViewDetails} />
        <MaintainanceTable
          allMaintenance={allMaintenance}
          onViewDetails={onViewMaintainDetails}
        />
      </div>
    </div>
  );
};

export default Home;
